goog.provide("shadow.js.shim.module$src$svg$controls$watch_svg$default");
shadow.js.shim.module$src$svg$controls$watch_svg$default = shadow.js.shim.module$src$svg$controls$watch_svg.default;
